export const allowedCountryCodes = ['GB', 'UK'];

export const appendMetaDescription = (description: string, date: string, time: string) => {
	return `${description} ${date} at ${time}.`;
};
